"use strict";
// Integrations registry — the single source of truth for the app-level
// integrations a generated app can enable (auth providers, payments, …).
// Consumed by the client (tile grid + Manage form), studio (config storage +
// validation), and the agent (skill routing). Adding an integration = add a
// manifest here + its runtime module + its skill (+ an optional broker provider).
//
// Since the plugin platform, the manifests live in ../plugins/catalog and this
// file keeps the legacy IntegrationManifest view derived from them.
Object.defineProperty(exports, "__esModule", { value: true });
exports.GOOGLE_AUTH = exports.EMAIL_PASSWORD_AUTH = exports.INTEGRATIONS = void 0;
exports.getIntegration = getIntegration;
exports.requiredFieldKeys = requiredFieldKeys;
exports.needsBrandingSetup = needsBrandingSetup;
exports.detectionTokenMap = detectionTokenMap;
const plugins_1 = require("../plugins");
// Derived from the plugin catalog (packages/shared/src/plugins). Every plugin
// with a `tile` is an integration; edit the plugin manifest, not this list.
exports.INTEGRATIONS = (0, plugins_1.integrationsFromPlugins)();
exports.EMAIL_PASSWORD_AUTH = exports.INTEGRATIONS.find((i) => i.id === 'email-password-auth');
exports.GOOGLE_AUTH = exports.INTEGRATIONS.find((i) => i.id === 'google-auth');
function getIntegration(id) {
    return exports.INTEGRATIONS.find((i) => i.id === id);
}
/** BYO keys required by an integration (for validating a saved config). */
function requiredFieldKeys(manifest) {
    return manifest.credentials.fields.map((f) => f.key);
}
/**
 * True when an integration is live but running on Dunea's shared credentials and
 * could be branded with the owner's own — i.e. worth flagging at deploy time.
 * `credentialMode` is the stored app_integrations mode ('shared' | 'byo').
 */
function needsBrandingSetup(manifest, credentialMode) {
    return manifest.credentials.mode === 'byo-optional' && credentialMode !== 'byo';
}
/** All source markers → their integration id, for the deploy-time source scan. */
function detectionTokenMap() {
    const map = {};
    for (const m of exports.INTEGRATIONS) {
        for (const token of m.detect ?? [])
            map[token] = m.id;
    }
    return map;
}
